import React from 'react';
import LazyImage from '../lib/LazyImage'
import Carousel from '../lib/Carousel'
import {Text} from '../field'
import ImageGallery from './ImageGallery'

export default class BlockImage extends React.Component {
	state = {
		galleryMode: 'mode-gallery',
		current: 0
	}
	renderCarousel = block => {
		return null
		/*
		if(!block.img) return null
		return (

		<ViewPager tag="carousel">
			<Frame className="frame" autoSize={true}>
				<Track
					ref={c => this.track = c}
					viewsToShow={1}
					infinite
					contain={true}
					className="track"
					>
					{block.img.map((img, i) => 
						<View className='view' key={i}>
							<LazyImage className='view-img' src={img} bg={true} proportional={block.proportional}/>
						</View>
					)}
				</Track>
			</Frame>
			<nav className="pager-controls">
				<a
					className="pager-control prev"
					onClick={() => this.track.prev()}
					>
					<i className='fa fa-angle-left'/>
				</a>
				<a
					className="pager-control next"
					onClick={() => this.track.next()}
					>
					<i className='fa fa-angle-right'/>
				</a>
			</nav>
		</ViewPager>
		)
		*/
	}
	componentDidMount() {
		this.html = document.querySelector('html')
		this.block = document.querySelector(`#block-${this.props.block.uuid}`)
		this.gallery = document.querySelector(`#block-${this.props.block.uuid} .gallery`)
		this.b = 0
		this.si = setInterval(() => {
			this.updateScroll()
		}, 1500)
	}
	updateScroll = () => {
		//console.log('update scroll')
		if(!this.block || !this.gallery) return
		const scroll = parseInt(this.html.style.getPropertyValue('--scroll'), 10)
		const b = this.block.getBoundingClientRect().top + scroll
		const s = this.gallery.getBoundingClientRect().top + scroll
		if (this.b===b) return
		this.block.style.setProperty('--scroll-gallery-block', b)
		this.gallery.style.setProperty('--scroll-gallery', s)
		this.b = b
	}
	componentWillUnmount() {
		this.block = null
		this.gallery = null
		if(this.si) clearInterval(this.si)
		this.si = null
	}
	galleryOpenCarousel = e => {
		const index = parseInt(e.currentTarget.getAttribute('data-index'), 10)
		if (this.block) this.block.style.zIndex = 100
		this.setState({galleryMode: 'mode-carousel', current: index})
	}
	
	galleryCloseCarousel = e => {
		if (this.block) this.block.style.zIndex = 0
		this.setState({galleryMode: 'mode-gallery'})
	}
	
	renderGallery = block => {
		const {screen} = this.props.config
		const {galleryMode, current} = this.state

		if(!block.img) return null
		return (
			<div className={`gallery ${galleryMode}`}>
				<div className='gallery-wrap'>
				<div className='gallery-gallery'>
					{block.img.map((img,i) => <div key={i} className='image'  data-index={i}
						onClick={this.galleryOpenCarousel}>
						<LazyImage src={img} imageStyle='gallery-th' alt='' screen={screen}/></div>)}
				</div>
				</div>
				<div className='gallery-carousel' key='carousel'>
					<div onClick={this.galleryCloseCarousel} className='back-to-gallery'><i className='fa fa-times'></i></div>
					<Carousel className='gallery-carousel' key='carousel' 
						items={block.img} imageStyle='gallery-full' current={current} proportional={true}/>
				</div>
			</div>
		)
	}
	render() {
		const {entity, block, config, menu, screen} = this.props
		//let style={}
        //if(block.bgColor) style={backgroundColor: block.bgColor}
		//if (block.ga && block.ga.trim()!=='') style.gridArea = block.ga
		
		return (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
	{/*className={classes} id={`block-${block.uuid}`} style={style}>*/}
		{(block.bg && block.bg.length>0)?<div className='bg-wrap'><LazyImage className='bg' src={block.bg[0]} alt='' bg={true} screen={screen}/></div>:null}
		{menu}
		
		{block.text &&
			<div className='text-content'><div className='text-wrap'>
				<Text entity={entity} block={block} fieldName='text' value={block.text}/>
			</div></div>
		}

		<div className='content'>
		{block.multiple
			?(block.carousel
				?this.renderCarousel(block)
				:<ImageGallery gallery={block.img}/>
			)
			
			:((block.img && block.img.length>0) ? <LazyImage className='img' src={block.img[0]} alt='' bg={true} screen={screen}/>:'')
		}
		</div>
	</div>
		)
	}
}
/*
		{!edit && <span className='img-edit' onClick={() => dispatch(ops.editMode({uuid:block.uuid}))}>
			/*<InsertPhoto style={{width: '100%', height: '100%', color: 'rgba(238, 238, 238, 0.7)'}}/>*
		</span>
		{edit && <span className='img-edit' onClick={() => dispatch(ops.editCancel())}>
			/*<InsertPhoto style={{width: '100%', height: '100%', color: 'rgba(238, 238, 238, 0.7)'}}/>*
		</span>

*/



// WEBPACK FOOTER //
// ./src/fm/block/BlockImage.js